<template>
  <header class="ts-header">
    <div class="ts-header-top">
      <router-link :to="{path: '/'}" class="ts-brand" title="TicketShop" tag="a">
        <img class="logo" src="../../../public/images/logo-ticketshop-ve.png" alt="TicketShop VE">
      </router-link>

      <form class="ts-search" @submit.prevent="buscar">
        <i class="material-icons ts-search-icon">search</i>
        <input
          v-model="busqueda"
          type="text"
          placeholder="Busca tu artista, ciudad o evento..."
          aria-label="Buscar eventos"
        >
        <button type="submit" class="ts-search-btn" title="Buscar">
          <i class="material-icons">search</i>
        </button>
      </form>

      <div class="ts-actions">
        <a v-if="!$store.state.user.accessToken" class="ts-login" href="#" @click.prevent="showModalLogin">
          <i class="material-icons">person_outline</i>
          <span>Iniciar sesión</span>
        </a>
        <div class="dropdown" v-if="$store.state.user.accessToken">
          <a class="ts-login dropdown-toggle" href="#" id="navbarDropdown" role="button" data-toggle="dropdown"
             aria-haspopup="true" aria-expanded="false" title="Mis opciones">
            <img src="/images/user.png" class="img-logged">
            <span>Mi cuenta</span>
          </a>
          <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
            <router-link class="dropdown-item" :to="{name: 'perfil'}">Mi perfil</router-link>
            <router-link class="dropdown-item" :to="{name: 'perfil', params: {optPerfil: 3}}" v-if="usuario.id_rol==2">Mis compras</router-link>
            <router-link class="dropdown-item" :to="{name: 'contacto'}">Soporte</router-link>

            <router-link class="dropdown-item" :to="{ name: 'misEventos' }"
                         v-if="usuario.id_rol==3 || usuario.id_rol==4 || usuario.id_rol==8 || usuario.id_rol==9 || usuario.id_rol==5 || usuario.id_rol==7">
              Mis eventos
            </router-link>
            <router-link class="dropdown-item" :to="{ name: 'PuntosVentaJefePunto' }"
                         v-if="usuario.id_rol==7">
              Puntos de venta
            </router-link>
            <router-link class="dropdown-item" :to="{ name: 'pagosParciales' }"
                         v-if="usuario.id_rol==5">
              Pagos parciales
            </router-link>
            <router-link class="dropdown-item" :to="{ name: 'eventosAprobacion' }" v-if="usuario.id_rol==6">Eventos
              aprobacion
            </router-link>

            <div class="dropdown-divider"></div>
            <a class="dropdown-item" href="#" @click.prevent="logout">Cerrar sesion</a>
          </div>
        </div>
        <button class="ts-toggler" type="button" data-toggle="collapse" data-target="#tsNavCollapse" aria-label="Menú">
          <i class="material-icons">menu</i>
        </button>
      </div>
    </div>

    <nav class="collapse ts-nav-collapse" id="tsNavCollapse">
      <ul class="ts-nav">
        <li><router-link to="/" exact class="ts-nav-link">Inicio</router-link></li>
        <li><a href="/#eventos" class="ts-nav-link" @click="irASeccion($event, 'eventos')">Eventos</a></li>
        <li><a href="/#ciudades" class="ts-nav-link" @click="irASeccion($event, 'ciudades')">Ciudades</a></li>
        <li><router-link to="/puntosVenta" class="ts-nav-link">Puntos de venta</router-link></li>
        <li><router-link to="/comunicados" class="ts-nav-link">Promociones</router-link></li>
        <li><router-link to="/mision" class="ts-nav-link">Nosotros</router-link></li>
        <li><a href="/pqr" class="ts-nav-link">Contacto</a></li>
      </ul>
    </nav>
  </header>
</template>
<script>
export default {
  data() {
    return {
      busqueda: this.$route.query.q || '',
    };
  },
  watch: {
    '$route.query.q'(q) {
      this.busqueda = q || '';
    },
  },
  methods: {
    logout() {
      this.$store.dispatch('logout');
    },
    showModalLogin() {
      this.$store.commit('showModalLogin', true);
    },
    buscar() {
      const q = this.busqueda.trim();
      this.$router.push({ path: '/', query: q ? { q } : {}, hash: '#eventos' }).catch(() => {});
      this.$nextTick(() => this.scrollA('eventos'));
    },
    irASeccion(e, id) {
      if (this.$route.path === '/') {
        e.preventDefault();
        this.scrollA(id);
      }
    },
    scrollA(id) {
      const el = document.getElementById(id);
      if (el) {
        el.scrollIntoView({ behavior: 'smooth' });
      }
    },
  },
  computed: {
    usuario() {
      return this.$store.getters['user/dataUserLogged'];
    },
    modalLogin() {
      return this.$store.getters['modalLogin'];
    },
  },
};
</script>
<style>
.ts-header,
.ts-header *:not(.material-icons):not(.v-icon):not(.mdi) {
  font-family: 'Montserrat', Raleway, sans-serif;
}
.ts-header {
  background: #0b0b0b url('/images/fondo-menu-ve.jpg') center / cover no-repeat;
  border-bottom: 1px solid rgba(212, 165, 55, .35);
  position: relative;
  z-index: 50;
}
.ts-header-top {
  display: flex;
  align-items: center;
  gap: 24px;
  max-width: 1280px;
  margin: 0 auto;
  padding: 14px 24px 6px;
}
.ts-brand img {
  width: 230px;
  height: auto;
  display: block;
}
.ts-search {
  flex: 1;
  max-width: 560px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  background: #fff;
  border-radius: 999px;
  overflow: hidden;
  padding-left: 14px;
}
.ts-search-icon {
  color: #777;
  font-size: 20px !important;
}
.ts-search input {
  flex: 1;
  border: 0;
  outline: none;
  padding: 10px 10px;
  font-size: 14px;
  color: #222;
  min-width: 0;
}
.ts-search-btn {
  background: linear-gradient(180deg, #f3d27a, #c8962e);
  border: 0;
  padding: 8px 20px;
  color: #1a1a1a;
  cursor: pointer;
  display: flex;
  align-items: center;
}
.ts-actions {
  display: flex;
  align-items: center;
  gap: 16px;
}
.ts-login {
  display: flex;
  align-items: center;
  gap: 6px;
  color: #fff !important;
  font-size: 14px;
  white-space: nowrap;
}
.ts-login:hover {
  color: #f3d27a !important;
}
.ts-toggler {
  display: none;
  background: transparent;
  border: 1px solid rgba(212, 165, 55, .6);
  border-radius: 6px;
  color: #f3d27a;
  padding: 4px 6px;
}
@media (min-width: 768px) {
  .ts-nav-collapse {
    display: block !important;
    height: auto !important;
  }
}
.ts-nav {
  list-style: none;
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 8px 34px;
  margin: 0;
  padding: 6px 24px 10px;
}
.ts-nav-link {
  color: #fff !important;
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: .5px;
  padding: 4px 0;
  border-bottom: 2px solid transparent;
  transition: color .2s, border-color .2s;
}
.ts-nav-link:hover,
.ts-nav-link.router-link-exact-active {
  color: #f3d27a !important;
  border-bottom-color: #d4a537;
}
.img-logged {
  max-width: 30px;
  box-shadow: 0px 3px 7px 2px rgb(0 0 0 / 60%);
  border-radius: 100%;
}
.ts-header .dropdown-menu {
  position: absolute !important;
}
.ts-header .dropdown-toggle::after {
  display: none !important;
}
.nav-link {
  color: white !important;
}
.nav-link:hover {
  color: #ffffffa4 !important;
}
/* Usados por buscadores de otras vistas */
.search .v-input__control {
  min-height: auto !important;
}
.search .v-input__slot {
  border-radius: 100px !important;
}
.dropdown-menu {
  position: absolute !important;
}
@media (max-width: 767px) {
  .ts-header-top {
    flex-wrap: wrap;
    gap: 12px;
    padding: 12px 16px;
  }
  .ts-brand img {
    width: 170px;
  }
  .ts-actions {
    margin-left: auto;
  }
  .ts-login span {
    display: none;
  }
  .ts-search {
    order: 3;
    flex-basis: 100%;
    max-width: none;
  }
  .ts-toggler {
    display: flex;
  }
  .ts-nav-collapse:not(.show) {
    display: none;
  }
  .ts-nav {
    flex-direction: column;
    align-items: center;
    gap: 10px;
  }
}
</style>
